var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomTo = function SvgZoomTo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.25 22.5v-4.387L9.958 19.39l-1.054-1.053L12 15.24l3.096 3.096-1.054 1.053-1.292-1.277V22.5zm-5.586-7.404L4.61 14.042l1.276-1.292H1.5v-1.5h4.387L4.61 9.958l1.053-1.054L8.76 12zm12.673 0L15.24 12l3.096-3.096 1.053 1.054-1.277 1.292H22.5v1.5h-4.387l1.277 1.292zM12 13.24q-.52 0-.88-.36t-.36-.88.36-.88q.36-.36.88-.36t.88.36.36.88q0 .52-.36.88t-.88.36m0-4.48L8.904 5.663 9.958 4.61l1.292 1.276V1.5h1.5v4.387l1.292-1.277 1.054 1.053z"
  })));
};
export default SvgZoomTo;